/*
 * @Descripttion: 个体税金及服务费订单
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'individual-proxy-fee';

export { name, route };
